'use strict';
/*
* Novicell master
* Use this file to call functions in other files, on document ready, window.resize etc.
*/

var novicell = novicell || {};
var projectName = projectName || {};

// Document ready
document.addEventListener('DOMContentLoaded', function(){
    novicell.cookieInfo.init();
    novicell.slideshow.init();    
    novicell.list.init();
    novicell.wizard.init();
    novicell.brandSlider.init();
    novicell.filterSection.init();
    novicell.keyNumbers.init();
    novicell.embedMedia.init();
    novicell.accordion.init();

    /* Helpers */
    novicell.helper.buttonsWithLink();

    /* Lib */
    novicell.aspnetValidation.init();
    
    //SetTimeout to fix latency with loaded elements in e.g. Vue components
    setTimeout(() => {
        svg4everybody(); // Fix SVG spritemap in IE/Edge
    });
});

document.addEventListener('scroll', function (e) {
    novicell.keyNumbers.init();
});

// Docs for debounce https://github.com/component/debounce
window.onscroll = novicell.debounce(onScroll, 100);

window.onresize = novicell.debounce(resize, 200);

function resize() {
    novicell.keyNumbers.init();
}
function onScroll() {
    novicell.keyNumbers.init();
}


if (!Element.prototype.matches) {
    Element.prototype.matches = Element.prototype.msMatchesSelector || 
    Element.prototype.webkitMatchesSelector;
}

if (!Element.prototype.closest) {
    Element.prototype.closest = function(s) {
        var el = this;
        
        do {
            if (Element.prototype.matches.call(el, s)) {
                return el;
            }
            el = el.parentElement || el.parentNode;
        } while (el !== null && el.nodeType === 1);
        return null;
    };
}
